import { render, staticRenderFns } from "./app-config-card.vue?vue&type=template&id=0e7275d2"
import script from "./app-config-card.vue?vue&type=script&lang=js"
export * from "./app-config-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports